/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DataVaxiomEmployeeProfessionalsRelationshipsItem/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Avatar from './Avatar/index'
import ContactInfo from './ContactInfo/index'
import Edit from './Edit/index'
import Menu from './Menu/index'
import Name from './Name/index'
import OfficeName from './OfficeName/index'
import Profession from './Profession/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function DataVaxiomEmployeeProfessionalsRelationshipsItem({
  children,
  viewPath = "/DesignSystem/DataVaxiomEmployeeProfessionalsRelationshipsItem"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="DataVaxiomEmployeeProfessionalsRelationshipsItem.Horizontal"
  data-view-path={viewPath}
 style={{'--pl-1-Z1y5HWL': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-2-Z1y5HWL': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-3-Z1y5HWL': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-4-Z1y5HWL': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="DataVaxiomEmployeeProfessionalsRelationshipsItem.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<Avatar
  viewPath={`${viewPath}/Avatar`}
/>
<div
  data-testid="DataVaxiomEmployeeProfessionalsRelationshipsItem.Vertical"
  data-view-path={viewPath}
 style={{'--ml-5-Z1y5HWL': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
>
<Name
  viewPath={`${viewPath}/Name`}
/>
<OfficeName
  viewPath={`${viewPath}/OfficeName`}
/>
</div>
</div>
<Profession
  viewPath={`${viewPath}/Profession`}
/>
<ContactInfo
  viewPath={`${viewPath}/ContactInfo`}
/>
<div
  data-testid="DataVaxiomEmployeeProfessionalsRelationshipsItem.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<Menu
  viewPath={`${viewPath}/Menu`}
/>
</div>
</div>
<Edit
  viewPath={`${viewPath}/Edit`}
/>
{children}
</React.Fragment>)
}